import { AccountsService } from 'base/accounts_service';
import { Preferences } from 'base/preferences';
import { makeObservable, observable } from 'mobx';
import { getUserJwt as defaultGetUserJwt } from '../library/src/modules/cookies';

export class PreferencesStore {
  @observable
  private preferences: Preferences = {
    // Optimistic state for preferences might be different from default values
    // e.g Expect pricing announcement dismissal so that it doesn't flash
    dismiss2024PricingAnnouncement: true,
    exportFormat: 'figma',
  };

  constructor(
    private readonly accountsService: AccountsService,
    private readonly getUserJwt = defaultGetUserJwt,
  ) {
    makeObservable(this);

    if (this.getUserJwt() != null) {
      this.accountsService
        .getPreferences()
        .then((res) => (this.preferences = res));
    }
  }

  public get<Key extends keyof Preferences>(key: Key): Preferences[Key] {
    return this.preferences[key];
  }

  public set<Key extends keyof Preferences>(key: Key, value: Preferences[Key]) {
    this.preferences[key] = value;
    void this.accountsService.updatePreference(key, value);
  }
}
